export default __webpack_public_path__ + "static/media/postgresql.7c0ecebe.svg";